const generateAvatarImage = (
    name, 
    size = 300, 
    bgColor = '#2D635B', 
    textColor = '#ffffff'
) => {
    if (!name || typeof name !== 'string') {
        name = '??';
    }

    const trimmedName = name.trim();
    let avatarText;

    if (trimmedName.includes(' ')) {
        const words = trimmedName.split(' ');
        avatarText = (words[0][0] + words[1][0]).toUpperCase();
    } else {
        avatarText = trimmedName.slice(0, 2).toUpperCase();
    }

    const canvas = document.createElement('canvas');
    canvas.width = size;
    canvas.height = size;

    const ctx = canvas.getContext('2d');

    ctx.fillStyle = bgColor;
    ctx.fillRect(0, 0, size, size);

    ctx.fillStyle = textColor;
    ctx.font = `${size / 2}px Arial`;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText(avatarText, size / 2, size / 2);

    return canvas.toDataURL('image/png');
};

export default generateAvatarImage;
